export enum TimelineTypeEnum {
  HORIZONTAL = "HORIZONTAL",
  VERTICAL = "VERTICAL",
  DIAGONAL_TOP_TO_BOTTOM = "DIAGONAL_TOP_TO_BOTTOM",
  DIAGONAL_BOTTOM_TO_TOP = "DIAGONAL_BOTTOM_TO_TOP",
}

export enum TimelineLeftBoundaryEnum {
  NOTHING = "NOTHING",
  LINE_SEGMENT = "LINE_SEGMENT",
  DOT = "DOT",
}

export enum TimelineRightBoundaryEnum {
  NOTHING = "NOTHING",
  LINE_SEGMENT = "LINE_SEGMENT",
  ARROW = "ARROW",
}
